// extracted by mini-css-extract-plugin
export var buttonContainer = "SponsoredProductModal_buttonContainer__s0mYO";
export var container = "SponsoredProductModal_container__KK25u";
export var modal = "SponsoredProductModal_modal__V1YR9";
export var overlay = "SponsoredProductModal_overlay__ajTvZ";
export var shared = "\"../../../shared/shared.module.css\"";
export var sm = "576px";